import Image, { ImageProps } from 'next/image';
import { HTMLAttributeAnchorTarget, MouseEvent } from 'react';

import { RATIO, Ratio } from '../../ratio/Ratio';
import { ReviewRating, ReviewRatingProps } from '../../review/rating/ReviewRating';
import { Typography } from '../../typography/Typography';

import style from './DestinationCard.module.css';

interface DestinationCardProps {
    href: string;
    image: ImageProps;
    target?: HTMLAttributeAnchorTarget;
    title: string;
    showReviewRating?: boolean;
    reviewRatingProps?: ReviewRatingProps;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export function DestinationCard({
    href,
    image,
    target,
    title,
    showReviewRating,
    reviewRatingProps,
    onClick,
}: DestinationCardProps) {
    return (
        <div className={style.card}>
            <Ratio ratio={RATIO['4/5']} className={style.imageRatio}>
                <Image {...image} alt={image.alt} fill className={style.image} />
            </Ratio>
            <a onClick={onClick} className={style.link} href={href} target={target}>
                <Typography scale="secondary-s-bold" className={style.title}>
                    {title}
                </Typography>
            </a>
            {showReviewRating && reviewRatingProps !== undefined ? (
                <ReviewRating {...reviewRatingProps} className={style.reviewsRating} />
            ) : null}
        </div>
    );
}

DestinationCard.PICTURE_RATIO = RATIO['4/5'];
